Vendd.Scripts.load(function () {
    'use strict';

    Vendd.MessageBus.publishAsync(Vendd.User, new Vendd.User.Messages.GetSessionState());
});